<!--
 * @Description: 机构注册表单组件
 * @Author: wanqian
 * @Date: 2022-05-19 16:43:52
-->
<template>
   <div class="reg-form-body">
     <!-- status审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回 -->
     <div v-if="reviewResult && reviewResult.status == 2">
      <review-result :review="reviewResult" />
     </div>
     <div class="reg-form-main-body" v-if="form && Object.keys(form).length">
       <el-form ref="regForm" :model="form" :rules="rules" label-position="right" label-width="150px">
        <div class="section-item person-message">
         <div class="section-item-head">
           <div class="blue-line"></div>
           <span>个人信息</span>
         </div>
         <el-row style="margin-top: 38px;" :gutter="10" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item label="姓名：" prop="adminName">
              <el-input size="small" style="width: 70%" v-model.trim="form.adminName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账户名：" prop="userName">
              <el-input size="small" style="width: 70%" v-model.trim="form.userName" placeholder="请输入账户名" 
                maxlength="30"></el-input>
            </el-form-item>
          </el-col>
         </el-row>
         <el-row :gutter="10" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input size="small" style="width: 70%" v-model.trim="form.mobile" placeholder="请输入手机号" readonly>
              </el-input>
            </el-form-item>
          </el-col>
         </el-row>
        </div>
        <div class="section-item inst-message">
          <div class="section-item-head">
            <div class="blue-line"></div>
            <span>机构信息</span>
          </div>
          <el-row style="margin-top: 38px;" :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="机构名称：" prop="name">
                <el-input size="small" style="width: 70%" v-model.trim="form.institutionDO.baseInfoDO.institution.name" 
                  placeholder="请输入机构名称" minlength="3" @input="inputInstitutionName()">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构所在省：" prop="province">
                <el-select size="small" style="width: 70%" 
                  v-model="form.institutionDO.baseInfoDO.institution.province" placeholder="请选择" filterable
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'provinceList', srcProvinceList, this))"
					        @visible-change="(visible) => 
                    commonUtil.handleListFilterVisibleChange(visible, 'provinceList', srcProvinceList, this)"
                  @change="handleProvinceChange">
                  <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="机构所在市：" prop="city">
                <el-select size="small" style="width: 70%" 
                  v-model="form.institutionDO.baseInfoDO.institution.city" placeholder="请选择" filterable
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'cityList', srcCityList, this))"
					        @visible-change="(visible) => 
                    commonUtil.handleListFilterVisibleChange(visible, 'cityList', srcCityList, this)"
                  @change="handleCityChange">
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构所在县：" prop="county">
                <el-select size="small" style="width: 70%" 
                  v-model="form.institutionDO.baseInfoDO.institution.county" placeholder="请选择" filterable
                  :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'countyList', srcCountyList, this))"
					        @visible-change="(visible) => 
                    commonUtil.handleListFilterVisibleChange(visible, 'countyList', srcCountyList, this)"
                  @change="handleCountyChange">
                  <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.name" />
                </el-select>
              </el-form-item>   
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="24">
              <el-form-item label="机构地址：" prop="addr">
                <el-input size="small" style="width:90%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.addr" placeholder="请输入机构地址"
                  oninput="if (value.length > 100) value = value.slice(0, 100)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="统一社会信用代码：" prop="bizLicense">
                <el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.bizLicense" placeholder="请输入统一社会信用代码"
							    oninput="if (value.length > 30) value = value.slice(0, 30)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人代表：" prop="legalPerson">
                <el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.legalPerson" placeholder="请输入法人代表姓名"
                  oninput="if (value.length > 20) value = value.slice(0, 20)" />
              </el-form-item>   
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="联系人姓名：" prop="contact">
                <el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.contact" placeholder="请输入联系人姓名"
                  oninput="if (value.length > 20) value = value.slice(0, 20)" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：" prop="contactNum">
                <el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.contactNum" placeholder="请输入联系电话" 
                  @input="inputContactNum()" oninput="if (value.length > 12) value = value.slice(0, 12)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="客服姓名：" prop="csr">
								<el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.csr" placeholder="请输入客服姓名"
									oninput="if (value.length > 20) value = value.slice(0, 20)" />
							</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客服电话：" prop="csTeleno">
								<el-input size="small" style="width: 70%" 
                  v-model.trim="form.institutionDO.baseInfoDO.institution.csTeleno" placeholder="请输入客服电话" 
                  @input="inputCsTeleno()" oninput="if (value.length > 12) value = value.slice(0, 12)" />
							</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item label="营业执照：" prop="picPath">
                <el-upload class="homepage-uploader" ref="homepageUpload" accept="image/jpeg,image/jpg,image/png" 
                  action="" :show-file-list="false" :auto-upload="false" :on-change="handlePicChange">
                  <el-image v-if="!picFile && !form.institutionDO.baseInfoDO.institution.licensePath" 
                    class="img-homepage" :src="picPath" fit="contain"></el-image>
                  <div v-if="!picFile && !form.institutionDO.baseInfoDO.institution.licensePath" 
                    style="color: #409EFF; font-size: 12px; height: 15px; margin-top: -15px">
                    点击上传
                  </div>
                  <div v-else style="width: 100%">
                    <el-image class="img-homepage-file" :src="picPath" fit="contain"></el-image>
                    <span class="text-license-hover">点击更换图片</span>
                  </div>
                </el-upload>
                <div class="tip-licensePath">
                  请上传宽度不小于600像素的图片，图片大小不超过<span class="tip-red">5M</span>
                  ，支持上传<span class="tip-red">png、jpg、jpeg</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="机构Logo：" prop="logoPath">
                <el-upload class="logo-uploader" ref="logoUpload" accept="image/jpeg,image/png" action="" 
                  :show-file-list="false" :auto-upload="false" :on-change="handleLogoChange">
                    <el-image v-if="!logoFile && !form.institutionDO.baseInfoDO.institution.logoPath" 
                      class="img-logo" :src="logoPath" fit="contain">
                    </el-image>
                    <div v-if="!logoFile&&!form.institutionDO.baseInfoDO.institution.logoPath" 
                      style="color: #409EFF; font-size: 12px; height: 15px; margin-top: -20px">
                      点击上传
                    </div>
                    <div v-else style="width: 64px">
                      <el-image class="img-logo-file" :src="logoPath" fit="contain"></el-image>
                      <span class="text-logo-hover" style="width: 64px">点击更换</span>
                    </div>
                </el-upload>
                <div class="tip-licensePath">
                  请上传宽度不小于100像素的图片，图片大小不超过<span class="tip-red">5M</span>
                  ，支持上传<span class="tip-red">png、jpg、jpeg</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="section-item open-service">
          <div class="section-item-head">
            <div class="blue-line"></div>
            <span>服务开通</span>
          </div>
          <div v-for="(openingHsvc, index) in form.institutionDO.openingHsvcList" :key="openingHsvc.id">
            <el-row style="margin: 30px 0 0 40px;" :gutter="10" type="flex" align="middle">
              <el-form-item label="" class="form-item-open-service">
                <el-checkbox v-model="openingHsvc.opened" disabled>{{openingHsvc.hsvcCategoryText}}</el-checkbox>
              </el-form-item>
              <el-form-item class="form-item-open-service" style="margin-left: 20px" label="" 
                :prop="'institutionDO.openingHsvcList.' + index + '.timeRange'" 
                :rules="{required: true, message: '请选择服务时间', trigger: 'blur'}">
                <el-time-picker style="width: 260px" size="small" v-model="openingHsvc.timeRange" is-range 
                  placeholder="选择时间范围" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" 
                  :clearable="false" format = 'HH:mm:ss' value-format = 'HH:mm:ss'
                  @change="handleTimePickerChange(openingHsvc, index)">
                </el-time-picker>
              </el-form-item>
              <el-form-item label="" class="form-item-open-service">
                <el-checkbox style="margin-left: 25px" v-model="openingHsvc.isWholeDay" 
                  :true-label="1" :false-label="0" 
                  @change="handleIsWholeDayChange(openingHsvc, index)">全天(24小时服务)</el-checkbox>
              </el-form-item>
            </el-row>
          </div>
        </div>
        <div class="div-agreement" v-if="!reviewResult">
          <el-checkbox style="width: 14px; height: 16px; text-align: left" v-model="checked"></el-checkbox>
          <span class="text-gray" style="margin-left: 10px;">我已阅读并同意</span>
          <span class="text-blue mouse-pointer" @click="handleXHYAdmissionNotice">《入驻须知》</span>
          <span class="text-gray">及</span>
          <span class="text-blue mouse-pointer" @click="handleXHYUsageAgreement">《{{title}}入驻协议》</span>
        </div>
       </el-form>
       <div class="footer">
         <el-button class="submit-btn" type="primary" @click="handleSaveClick">提交审核</el-button>
       </div>
     </div>
   </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
import ReviewResult from '../../common/components/ReviewResult.vue'

export default {
  name: 'InstRegForm',
  props: ['reviewResult'],

  components: {
    'review-result': ReviewResult,
  },

  data() {
    // 注意：以下把机构信息相关的验证都用自定义规则处理，因为prop的层次和model绑定的层次不在相同,机构信息有多层
		let validateUserName = (_rule, _value, callback) => {
			let excludeId = this.form && this.form.adminId ? this.form.adminId : 0;
      let params = {
        'username': this.form.userName,
        'excludeId': excludeId
      };
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_IS_UNIQUE_USERNAME,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
			this.vueRequest(requestData).then(result => {
        if (result != null) {
					if (result.data) {
						callback();
					} else {
						callback(new Error('账户名已存在，请试试其他账户名吧'));
					}
        }
      })
    };

    let validName = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.name) {
			  callback(new Error('请输入机构名称'));
			} else if (this.form.institutionDO.baseInfoDO.institution.name.length < 3) {
        callback(new Error('输入机构名称字数至少为3'))
      } else {
			  callback()
			}
		};

    let validProvince = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.province) {
			  callback(new Error('请选择机构所在省'))
			} else {
			  callback()
			}
		};

    let validCity = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.city) {
			  callback(new Error('请选择机构所在市'))
			} else {
			  callback()
			}
		};

    let validCounty = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.county) {
			  callback(new Error('请选择机构所在县'))
			} else {
			  callback()
			}
		};

    let validAddr = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.addr) {
			  callback(new Error('请输入机构地址'))
			} else {
			  callback()
			}
		};

    let validBizLicense = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.bizLicense) {
			  callback(new Error('请输入统一社会信用代码'))
			} else {
			  callback()
			}
		};

    let validLegalPerson = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.legalPerson) {
			  callback(new Error('请输入法人代表姓名'))
			} else {
			  callback()
			}
		};

    let validContact = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.contact) {
			  callback(new Error('请输入联系人姓名'))
			} else {
			  callback()
			}
		};

    let validContactNum = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.contactNum) {
			  callback(new Error('请输入联系人电话'))
			} else {
			  callback()
			}
		};

    let validCsr = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.csr) {
			  callback(new Error('请输入客服姓名'))
			} else {
			  callback()
			}
		};

    let validCsTeleno = (_rule, _value, callback) => {
			if (!this.form.institutionDO.baseInfoDO.institution.csTeleno) {
			  callback(new Error('请输入客服电话'))
			} else {
			  callback()
			}
		};

		let validatePic = (_rule, _value, callback) => {
			if (!this.picPath || this.picPath == require('@/assets/common/img-common-chooseimg.png')) {
				callback(new Error('请上传营业执照'));
			} else {
				callback();
			}
    };

    return {
      form: {},
      rules: {
        adminName: [{required: true, message: '请输入姓名', trigger: 'blur'},
								    {	min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}],
        userName: [{required: true, message: '请输入账户名', trigger: 'blur'},
									 {required: true,	validator: validateUserName, trigger: 'blur'},],
        name: [{required: true, validator: validName, trigger: 'blur'},],
        province: [{required: true, validator: validProvince, trigger: 'blur'}],
        city: [{required: true, validator: validCity, trigger: 'blur'}],
        county: [{required: true, validator: validCounty, trigger: 'blur'}],
        addr: [{required: true, validator: validAddr, trigger: 'blur'},],
        bizLicense: [{required: true, validator: validBizLicense, trigger: 'blur'},],
				legalPerson: [{required: true, validator: validLegalPerson, trigger: 'blur'},],
        contact: [{required: true, validator: validContact, trigger: 'blur'},],
				contactNum: [{required: true, validator: validContactNum, trigger: 'blur'},],
        csr: [{required: true, validator: validCsr, trigger: 'blur'},],
				csTeleno: [{required: true, validator: validCsTeleno, trigger: 'blur'},],
				picPath: [{required: true, validator: validatePic, trigger: 'blur'}],
      },
      provinceList: [],
      srcProvinceList: [],
      cityList: [],
			srcCityList: [],
      countyList: [],
			srcCountyList: [],
      picFile: null,
      logoFile: null,
      checked: false,
      title: '星护云',
    }
  },

  computed: {
    picPath() {
      if (this.picFile) return this.commonUtil.file2Url(this.picFile);
      return this.form.institutionDO.baseInfoDO.institution.licensePath 
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE
          , this.form.institutionDO.baseInfoDO.institution.licensePath)
        : require('@/assets/common/img-common-chooseimg.png');
    },

    logoPath() {
      if (this.logoFile) return this.commonUtil.file2Url(this.logoFile);
      return this.form.institutionDO.baseInfoDO.institution.logoPath 
        ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE
          , this.form.institutionDO.baseInfoDO.institution.logoPath)
        : require('@/assets/common/img-common-chooseimg.png');
    },
  },
  
  methods:{
    getDo() {
      // status审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回
      let url = this.reviewResult && this.reviewResult.status == 2 
        ? Constant.URL_GET_REGISTER_INSTITUTION_DO_4_UPDATE
        : Constant.URL_GET_REGISTER_INSTITUTION_DO_4_ADD;
      let params = (this.reviewResult && this.reviewResult.status == 2) ? {id: this.reviewResult.institutionId} : {};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
			this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.form = result.data;
          this.provinceList = result.data.institutionDO.baseInfoDO.provinceList;
          this.srcProvinceList = result.data.institutionDO.baseInfoDO.provinceList;
					if (this.form.institutionDO.baseInfoDO.institution.provinceId) {
						this.requsetCityList(this.form.institutionDO.baseInfoDO.institution.provinceId);
					}
					if (this.form.institutionDO.baseInfoDO.institution.cityId) {
						this.requsetCountyList(this.form.institutionDO.baseInfoDO.institution.cityId);
					}
          this.rebuildOpenHserviceData();
          this.clearVaild();
        }
      })
    },

    //输入机构名称
    inputInstitutionName() {
      this.form.institutionDO.baseInfoDO.institution.name = 
        this.handleInstName(this.form.institutionDO.baseInfoDO.institution.name, true);
      if (this.form.institutionDO.baseInfoDO.institution.name.length > 32) {
        this.form.institutionDO.baseInfoDO.institution.name = 
          this.form.institutionDO.baseInfoDO.institution.name.slice(0, 32);
      }
      let name = this.handleInstName(this.form.institutionDO.baseInfoDO.institution.name, false);
      this.form.institutionDO.baseInfoDO.institution.identifier = this.pinyin.getCamelChars(name);
      this.form.institutionDO.baseInfoDO.institution.identifier = this.handleZQToCQ(
        this.form.institutionDO.baseInfoDO.institution.name, this.form.institutionDO.baseInfoDO.institution.identifier);
			if (this.form.institutionDO.baseInfoDO.institution.identifier.length > 20) {
        this.form.institutionDO.baseInfoDO.institution.identifier = 
          this.form.institutionDO.baseInfoDO.institution.identifier.slice(0, 20);
      }
    },

    handleInstName(str, containBrackets) {
      // 机构名称只能输入汉字、数字、中文英文的括号
      return Util.filterChineseAndDigitalsAndBrackets(str, containBrackets);
    },

    //特殊处理机构名称带有重庆转换后是ZQ的问题
    handleZQToCQ(name, identify) {
      return Util.changeIdentifyOfZQToCQ(name, identify);
    },

    //选择省
    handleProvinceChange(value) {
      this.form.institutionDO.baseInfoDO.institution.provinceId = 
        Util.searchKeyWithValueInArr('name', value, this.provinceList).id;
      this.form.institutionDO.baseInfoDO.institution.city = "";
      this.form.institutionDO.baseInfoDO.institution.cityId = "";
      this.form.institutionDO.baseInfoDO.institution.county = "";
      this.form.institutionDO.baseInfoDO.institution.countyId = "";
      this.requsetCityList(this.form.institutionDO.baseInfoDO.institution.provinceId);
    },

    //请求市数据
    requsetCityList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_CITY, id);
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          this.cityList = result.data;
          this.srcCityList = result.data;
        }
      });
    },

    //选择市
    handleCityChange(value) {
      this.form.institutionDO.baseInfoDO.institution.cityId = Util.searchKeyWithValueInArr('name', value, this.cityList).id;
      this.form.institutionDO.baseInfoDO.institution.county = "";
      this.form.institutionDO.baseInfoDO.institution.countyId = "";
      this.requsetCountyList(this.form.institutionDO.baseInfoDO.institution.cityId);
    },

    //请求县数据
    requsetCountyList(id) {
      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_LIST_COMMON_COUNTY, id);
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          this.countyList = result.data;
          this.srcCountyList = result.data;
        }
      });
    },

    //选择县
    handleCountyChange(value) {
      this.form.institutionDO.baseInfoDO.institution.countyId = 
        Util.searchKeyWithValueInArr('name', value, this.countyList).id;
    },

    //输入联系人电话
    inputContactNum() {
      this.form.institutionDO.baseInfoDO.institution.contactNum = 
        this.commonUtil.filterDigitals(this.form.institutionDO.baseInfoDO.institution.contactNum, ['-']);
    },

    //输入客服电话
		inputCsTeleno() {
			this.form.institutionDO.baseInfoDO.institution.csTeleno = 
        this.commonUtil.filterDigitals(this.form.institutionDO.baseInfoDO.institution.csTeleno, ['-']);
		},

    //选择营业执照改变
    handlePicChange(file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 600.0,
        maxHeight: 0,
        extLimit: {
          limitType: 2,
          minRatio: 0.1,
          minRatioText: '100:10',
        },
        returnData: {}
      };
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
          this.picFile = data.file;
        }
        this.$refs.regForm.clearValidate('picPath');
      })
    },

    //选择logo改变
    handleLogoChange(file, _fileList) {
      let limitation = {
        maxSize: Constant.LIMIT_IMG_SIZE_5,
        maxWidth: 100.0,
        maxHeight: 0,
        extLimit: {
          limitType: 1,
          minRatio: 0.4,
          minRatioText: '100:40',
          maxRatio: 1.5,
          maxRatioText: '100:150'
        },
        returnData: {}
      };
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
        if (data.errorText && data.errorText.length) {
          this.$message.error(data.errorText);
        } else {
					this.logoFile = data.file;
        }
      })
    },

    //选择时间改变
    handleTimePickerChange(item, index) {
      if (item.timeRange[0] == "00:00:00" && item.timeRange[1] == "23:59:59") {
        item.isWholeDay = 1;
      } else {
        item.isWholeDay = 0;
      }
      this.form.institutionDO.openingHsvcList.splice(index, 1);
      this.form.institutionDO.openingHsvcList.splice(index, 0, item);
    },

    //全天切换
    handleIsWholeDayChange(item, index) {
      if (item.isWholeDay == 1) {
        item.startTime = "00:00:00";
        item.endTime = "23:59:59";
        let startTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + item.startTime);
        let endTimeDate = this.dateUtil.dateTimeFormat('2016-09-10 ' + item.endTime);
        item.timeRange = [startTimeDate, endTimeDate];
        this.form.institutionDO.openingHsvcList.splice(index, 1);
        this.form.institutionDO.openingHsvcList.splice(index, 0, item);
      }
    },

    rebuildOpenHserviceData() {
      //后台返回时间数据只有时分秒，人为拼接上临时日期，用于timePicker显示交互，在提交是会去掉拼接的日期
      let arr = this.form.institutionDO.openingHsvcList;
      let openingHsvcList = [];
      if (!arr) {
        this.$set(this.form.institutionDO, 'openingHsvcList', []);
        return;
      }
      arr.forEach((element) => {
        if (element.startTime && element.endTime) {
          let startTime = "2016-09-10 " + element.startTime;
          let endTime = "2016-09-10 " + element.endTime;
          let startTimeDate = this.dateUtil.dateTimeFormat(startTime);
          let endTimeDate = this.dateUtil.dateTimeFormat(endTime);
          this.$set(element, 'timeRange', [startTimeDate, endTimeDate]);
        }
        openingHsvcList.push(element);
      });
      this.$set(this.form.institutionDO, 'openingHsvcList', openingHsvcList);
    },

    handleSaveClick() {
      this.$refs['regForm'].validate((valid) => {
        if (!valid) return false;
        this.submitData();
      })
    },

    submitData() {
      if (!this.reviewResult && !this.checked) {
        this.$message.error('请阅读并同意《入驻须知》及《' + title + '入驻协议》');
        return;  
      }
      let url = this.reviewResult && this.reviewResult.status == 2 ? Constant.URL_UPDATE_REGISTER_INSTITUTION 
        : Constant.URL_SAVE_REGISTER_INSTITUTION;
      let method = this.reviewResult && this.reviewResult.status == 2 ? 'PUT' : 'POST';
      let obj = {
                  'name': this.form.adminName,
                  'username': this.form.userName,
                  'institution': this.form.institutionDO.baseInfoDO.institution,
                  'openingHsvcList': this.filterOpeningHsvcList(this.form.institutionDO.openingHsvcList)
                };
      let param = {'name': 'regInsVO', 'value': {...obj}};
      let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let fileMap = new Map();
      if (this.logoFile && this.logoFile.raw) {
				fileMap.set('logoFile', this.logoFile.raw)
			}
			if (this.picFile && this.picFile.raw) {
				fileMap.set('licenseFile', this.picFile.raw);
			}
      let requestData = {
        url: url,
        method: method,
        contentType: this.commonConst.CNTYPE_JSON,
        header: header,
        param: esParams,
        files: fileMap
      };

      this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.clearData();
          this.$emit('submitSuccess');
        }
      })    
    },

    //入驻须知
		handleXHYAdmissionNotice() {
      if (this.title == '悠心陪护') {
        window.open(Constant.URL_SDJK_XHY_ADMISSION_NOTICE, '_blank');
      } else {
        window.open(Constant.URL_XHY_ADMISSION_NOTICE, '_blank');
      }
		},

    //星护云使用协议
		handleXHYUsageAgreement() {
      if (this.title == '悠心陪护') {
        window.open(Constant.URL_SDJK_XHY_USAGE_AGREEMENT, '_blank');
      } else {
        window.open(Constant.URL_XHY_USAGE_AGREEMENT, '_blank');
      }
		},

    //过滤开通服务列表去掉逻辑显示用的timeRange字段
    filterOpeningHsvcList(list) {
      let self = this;
      let opendList = [];
      let arr = JSON.parse(JSON.stringify(list));
      arr.forEach((item) => {
        item.startTime = item.timeRange[0].indexOf('2016-09-10 ') == -1 ? item.timeRange[0] 
          : item.timeRange[0].substr(11);
        item.endTime = item.timeRange[1].indexOf('2016-09-10 ') == -1 ? item.timeRange[1] 
          : item.timeRange[1].substr(11);
        self.$delete(item, 'timeRange');
        opendList.push(item)
      })
      return opendList;
    },

    clearVaild() {
      if (!this.$refs || !this.$refs['regForm']) return;
    	this.$nextTick(() => {
        this.$refs['regForm'].clearValidate();
      });
		},

    clearData() {
      this.form = {};
    },
  },

  mounted() {
    this.getDo();

    this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        this.title = '悠心陪护'
      } else {
        this.title = '星护云'
      }
    });
  }
}
</script>

<style scoped>
.reg-form-body {
  margin: 0;
  padding: 80px 50px;
  text-align: left;
  border: solid 0px;
}
.section-item {
  margin-top: 30px;
}
.section-item-head {
  display: flex;
  align-items: center;
}
.section-item-head span {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}
.blue-line {
  width: 4px;
  height: 13px;
  background: #2A98FF;
  border-radius: 1px;
  margin-right: 12px;
}
.logo-uploader {
	background-color: #EBEEF2;
	width: 64px;
	height: 64px;
	text-align: center;
}
.homepage-uploader {
	background-color: #EBEEF2;
	width: 100%;
	height: 162px;
	text-align: center;
}
.img-logo { 
	width: 64px;
	height: 18px; 
	margin-top: 13px;
}
.img-homepage { 
	width: 64px;
	height: 26px; 
	margin-top: 53px;
}
.img-logo-file {
  height: 64px;
  margin: 0px;
}
.img-homepage-file {
  height: 162px;
  margin: 0px;
}
.el-upload:hover .text-license-hover,.el-upload:hover .text-logo-hover {
  display: block; 
}
.text-logo-hover {
  display: none;
  font-size: 8px;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width:64px;
  height: 64px;
  line-height: 64px;
  background: rgba(124,124,124,0.5500);
  font-weight: 600;
  color: #FFFFFF;
}
.text-license-hover {
	display: none;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 162px;
  line-height: 162px;
  background: rgba(124,124,124,0.5500);
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
}
.tip-logo {
  margin-left: 7px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.tip-licensePath {
  margin-top: 11px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
}
.footer {
  margin-top: 50px;
  text-align: center;
}
.submit-btn {
  width: 300px;
  font-weight: 600;
  font-size: 15px;
}
.div-agreement {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 15px;
}
.div-agreement .text-gray {
  color: #999999;
}
.div-agreement .text-blue {
  color: #3377FF;
}
.tip-red {
  color: #FF1515;
}
</style>
<style>
.reg-form-body .form-item-open-service .el-form-item__content {
  margin-left: 0px !important;
}
.reg-form-body .el-upload {
  width: 100%;
  height: 100%;
}
</style>>


// WEBPACK FOOTER //
// src/components/login/components/InstRegForm.vue